<template>
  <header class="header">
    <a href="/" class="logo cursor-pointer">
      <img :src="require(`../../../../static/imgs/exhibition/logo.png`)" alt="logo">
    </a>
    <div class="vc gap-16">
      <el-button v-if="showLogout" type="text" @click="logOut">{{ $t('components.header.logOut') }}</el-button>
      <lang class="login-header" />
    </div>
  </header>
</template>

<script>
import lang from '../header/lang.vue'
import { createNamespacedHelpers } from 'vuex'
const {
	mapGetters: userMapGetters,
	mapActions: userMapActions
} = createNamespacedHelpers('user')

/**
 * 接受index.vue 一个toLink参数，用以实现重置密码页面头部显示的文字为返回登录
 * 2017-09-06
 * by may */
export default {
  name: 'LoginHeader',
  components: { lang },
  props: {
    toLink: {
      type: Object,
      default() {
        return {
          text: 'pay'
        }
      }
    }
  },
  computed: {
    ...userMapGetters(['logoutInfo', 'accountCenterInfo']),
    showLogout() {
      const path = this.$route.path;
      return path === '/aq/pp-auth' && this.accountCenterInfo.clientId
    },
  },

  methods: {
		...userMapActions(['getLogoutInfo']),
    
    // 退出登录
    async logOut() {
      // 用户登出
      // 清空路由
      this.$store.dispatch('routerLogout')
      this.$store.dispatch('user/logout')
      await this.getLogoutInfo()
      if (this.logoutInfo === '提交成功' || this.logoutInfo === 'SUCCESS') {
        sessionStorage.removeItem('accessToken')
        localStorage.removeItem('isAlert')
        const params = new URLSearchParams(location.search)
        const query = params.toString()
        this.$jump({ path: `/aq/authLogin${query ? `?${query}` : ''}` })
      } else {
        this.$message.error(this.$t('components.header.logoutFailed')) // "登出失败，请稍后再试");
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  padding: 24px 40px;

  @media (max-width: 1200px) {
    padding: 24px;
  }

  .logo {
    width: 156px;

    > img {
      width: 100%;
      height: auto; /* Maintain aspect ratio */
    }

    @media (max-width: 720px) {
      width: 113px;
    }
  }

  .login-header {
    padding-top: 8px;

    @media (max-width: 720px) {
      padding-top: 0;
    }
  }

  .cursor-pointer {
    cursor: pointer;
  }

  @media (max-width: 720px) {
    padding: 21px 16px;
  }
}
</style>
